module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1045-e0f6d3b92317015a8b0b5bdfe07014cb.png";